import { CSSProperties } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import clsx from 'clsx'

import Button from 'shared/ui/Button'

import styles from './ControlledDot.module.scss'

interface ControlledDotProps {
  name: string
  value: string
  defaultValue: string
}

export function ControlledDot({
  name,
  value,
  defaultValue,
  ...props
}: ControlledDotProps) {
  const { control } = useFormContext()

  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <Button
            variant='neutralOutline'
            type='button'
            onClick={() => field.onChange(value)}
            className={clsx(styles.colorButton, {
              [styles.selected]: field.value === value
            })}
            {...props}
          >
            <div
              className={styles.color}
              style={{ '--dot-color': value } as CSSProperties}
            />
          </Button>
        )
      }}
    />
  )
}
